import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import { FaTrash } from "react-icons/fa";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, DELETE_DOCTOR } from "../../API";

function DoctorManagement() {
  const navigate = useNavigate();
  const { allDocotors, doctorPagination, getAllDoctors, headers } = useContext(ProfileContext)
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this doctor?")) return;
    
    setIsLoading(true);
    try {
      const response = await axios.delete(`${BASE_URL}${DELETE_DOCTOR}?_id=${id}`, { headers });
      if (response.data.status === true) {
        toast.success(response.data.message);
        getAllDoctors(doctorPagination?.currentPage || 1);
      } else {
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error_description || "An error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  const getPaginationText = () => {
    if (!doctorPagination || doctorPagination.totalCount === 0) { return }

    const start = (doctorPagination.currentPage - 1) * doctorPagination.limit + 1;
    const end = Math.min(doctorPagination.currentPage * doctorPagination.limit, doctorPagination.totalCount);
    return `${start}-${end} of ${doctorPagination.totalCount} items`;
  };

  const handleNext = () => {
    if (doctorPagination && doctorPagination.currentPage < doctorPagination.totalPages) {
      setIsLoading(true);
      getAllDoctors(doctorPagination.currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (doctorPagination && doctorPagination.currentPage > 1) {
      setIsLoading(true);
      getAllDoctors(doctorPagination.currentPage - 1);
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Doctor Management</h6>
                  <p className="comm_page_sub_heading">
                    Receive AI-driven diagnostic suggestions based on consultation
                    data, helping guide accurate and timely treatment decisions
                  </p>
                </div>

                <div className="modal_pair_btns patient_referral_btns ">
                  <button className='main-btn' onClick={() => navigate('/add-doctor')}>Add Doctor</button>
                </div>
              </div>

              <div className="comm-table pt-0 refferal_table_outer">
                <Table>
                  <thead>
                    <tr className="head-class-td">
                      <th>Sr. no.</th>
                      <th>license Number</th>
                      <th>Doctor Name</th>
                      <th>Email</th>
                      <th>Department</th>
                      <th width="10%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allDocotors && allDocotors.length > 0 ?
                      allDocotors.map((doc, index) => {
                        return (
                          <tr key={doc._id}>
                            <td>{index + 1}</td>
                            <td className="id_txt">#26475</td>
                            <td>{doc?.name}</td>
                            <td>{doc?.email}</td>
                            <td>{doc?.specialization}</td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <Link className="table-view-btn" to="/view-doctor" state={doc} title="View/Edit">
                                  <RiEyeLine />
                                </Link>
                                <button className="table-view-btn text-danger bg-transparent border-0 p-0" onClick={() => handleDelete(doc._id)} title="Delete">
                                  <FaTrash size={14} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                      :
                      <tr><td colSpan={5}>No Doctors yet!!</td></tr>
                    }
                  </tbody>
                </Table>
              </div>
              {allDocotors && allDocotors.length > 10 &&
                <div className="d-flex table_bottom_row">
                  <h4 className="page_count_txt">{getPaginationText()}</h4>
                  <div className="d-flex btn_grp">
                    <button className="table_bott_btn" onClick={handlePrevious} disabled={!doctorPagination || doctorPagination.currentPage <= 1}>Previous</button>
                    <button className="table_bott_btn" onClick={handleNext} disabled={!doctorPagination || doctorPagination.currentPage >= doctorPagination.totalPages}>Next</button>
                  </div>
                </div>
              }
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorManagement;
